// lib
import { createAction } from "@reduxjs/toolkit";

export const CACHE_DELAY = 120000; // 2 minutes
// calendar cache
export const cacheEvents = createAction("events/cache");
export const recompute = createAction("events/recompute");
export const refresh = createAction("events/refresh");
export const eventsRequest = createAction("events/request");
export const eventsSuccess = createAction("events/success");
export const eventsFailure = createAction("events/failure");
